export default "__VITE_ASSET__A12WKzTQ__";